import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button } from '@mui/material'
import moment from 'moment'

const ShowNoteDialog = ({ open, onClose, note }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Show Note</DialogTitle>
      <DialogContent>
        <TextField margin="dense" label="Note" type="text" fullWidth defaultValue={note?.content} multiline rows={3} />
        <TextField margin="dense" label="Created by" type="text" fullWidth value={note?.created_by} disabled />
        <TextField
          margin="dense"
          label="Created at"
          type="text"
          fullWidth
          value={note?.created_at ? moment(note?.created_at).format('LLL') : '-'}
          disabled
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}
export default ShowNoteDialog
